<template>
    <!-- 添加/编辑任务 -->
    <el-dialog title="任务" :visible.sync="addApiFlag">
        <el-form label-width="120px" :model="formParam" :rules="rules" ref="taskForm">
            <el-form-item label="策略">
                <el-select v-model="strategyData" placeholder="请选择策略" @change="strategySelectEvent($event)"
                :disabled="selectDisabled">
                    <el-option v-for="(st, index) in strategyList" :key="'st_'+index"
                    :label="st.names" :value="st.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="API">
                <el-select v-model="formParam.apiId" placeholder="请选择API" v-if="dialogType == 'add'">
                    <el-option v-for="(st, index) in apiAllData" :key="'api_'+index"
                    :label="st.name+'--'+st.username" :value="st.id"></el-option>
                </el-select>
                <el-input v-else-if="dialogType == 'edit'" v-model="formParam.apiId"></el-input>
            </el-form-item>
            <el-form-item v-if="userLevel == '1'" label="优先级" prop="priority">
                <el-input v-model="formParam.priority" placeholder="0~5, 值越大，优先级越高"></el-input>
            </el-form-item>
            <!-- <el-form-item label="币种" v-if="dialogType == 'add'">
                <el-switch
                v-model="formParam.currencyType"
                active-text="USD"
                inactive-text="USDT"
                active-value="usd" inactive-value="usdt">
                </el-switch>
            </el-form-item> -->
            <el-form-item label="看多杠杆倍数" prop="positive_leverage">
                <el-input v-model="formParam.positive_leverage" placeholder="看多杠杆倍数"></el-input>
            </el-form-item>
            <el-form-item label="看空杠杆倍数" prop="negative_leverage">
                <el-input v-model="formParam.negative_leverage" placeholder="看空杠杆倍数"></el-input>
            </el-form-item>
            <el-form-item label="是否允许开多" prop="is_buy">
                <el-switch class="form-switch" v-model="formParam.is_buy"></el-switch>
                <!-- <el-input v-model="formParam.isBuy" placeholder="0为不允许，1为允许"></el-input> -->
            </el-form-item>
            <el-form-item label="是否允许开空" prop="is_sell">
                <el-switch class="form-switch" v-model="formParam.is_sell"></el-switch>
                <!-- <el-input v-model="formParam.isSell" placeholder="0为不允许，1为允许"></el-input> -->
            </el-form-item>
            <el-form-item label="止损百分数" prop="stop_loss">
                <el-input v-model="formParam.stop_loss" placeholder="止损百分数 0~100"></el-input>
            </el-form-item>
            <el-form-item label="当前成本" prop="calculate_cost">
                <el-input v-model="formParam.calculate_cost" placeholder="当前成本"></el-input>
            </el-form-item>
            <el-form-item label="初始成本" prop="initial_cost">
                <el-input v-model="formParam.initial_cost" placeholder="投入成本"></el-input>
            </el-form-item>
            <el-form-item label="归档币种" prop="archive_currency">
                <el-input v-model="formParam.archive_currency" placeholder="归档最终币种"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="addApiFlag = false">取消</el-button>
            <el-button type="primary" @click="addApiBtn">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getUTaskEditData, getApiList, getUStrategyList, postUTaskEditData, postUnilateralTask } from "@/api/api.js";
import { mapState } from "vuex";

export default {
    data: function () {
        var validatepriority = (rule, value, callback) => {
            if (Number(value) < 0 || Number(value) > 5) {
                callback(new Error('值大小在0~5之间!'));
            }
            callback();
        };

        var validateLoss = (rule, value, callback) => {
            if (Number(value) < 0 || Number(value) > 100) {
                callback(new Error('值大小在0~100之间!'));
            }
            callback();
        }

        return {
            addApiFlag: false,
            formParam: {
                positive_leverage: '',
                negative_leverage: '',
                is_buy: true,
                is_sell: true,
                stop_loss: '',
                archive_currency: '',
                currencyType: 'usd'
            },
            dialogType: 'add',
            apiAllData: [],
            tipConifg: {
                title: '提示',
                message: '',
                offset: 100
            },
            strategyList: [],
            otherData: '',
            strategyData: '',
            selectDisabled: false,
            rules: {
                positive_leverage: [
                    { required: true, message: '杠杆倍数不能为空!', trigger: 'blur' }
                ],
                negative_leverage: [
                    { required: true, message: '杠杆倍数不能为空!', trigger: 'blur' }
                ],
                stop_loss: [
                    { required: true, message: '止损百分数不能为空!', trigger: 'blur' },
                    { validator: validateLoss, trigger: 'blur' }
                ],
                archive_currency: [
                    { required: false, message: '归档币种不能为空!', trigger: 'blur' }
                ],
                priority: [
                    { required: true, message: '优先级不能为空!', trigger: 'blur' },
                    { validator: validatepriority, trigger: 'blur' }
                ],
                is_buy: [
                    { required: true, message: '是否做多必选！', trigger: 'blur'},
                ],
                is_sell: [
                    { required: true, message: '是否开空必选！', trigger: 'blur'}
                ],
                calculate_cost: [
                    { required: false, message: '当前成本不能为空', trigger: 'blur'}
                ],
                initial_cost: [
                    { required: false, message: '投入成本不能为空', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        
    },
    computed: {
        ...mapState([
            'token',
            'userLevel'
        ])
    },
    methods: {
        initDialog(aid, type, sdata) {// 打开 dialog
            this.dialogType = type;
            this.addApiFlag = true;
            this.initUsedFnc();
            sdata ? this.otherData = sdata : this.otherData = '';
            if (type == 'edit') {
                getUTaskEditData({token: this.token, apiId: aid}).then(res => {
                    if (res.code === 200) {
                        this.formParam = res.data;
                        this.formParam['strategyId'] = res.data.strategy_id;
                        this.formParam['apiId'] = res.data.api_id;
                        this.formParam['taskId'] = res.data.id;
                        this.formParam['is_buy'] = res.data.is_buy ? true : false;
                        this.formParam['is_sell'] = res.data.is_sell ? true: false;
                        this.strategyData = res.data.names;
                    } else {
                        this.tipConifg['message'] = res.info;
                        this.$notify.error(this.tipConifg);
                    }
                });
            } else if (type == 'add') {
                if (sdata) {
                    this.formParam['strategyId'] = sdata.strategyId;
                    this.strategyData = sdata.names;
                    this.selectDisabled = true;
                }
            }

        },

        initUsedFnc() {// 函数初始化
            getApiList({token: this.token}).then(res => {
                if (res.code === 200) {
                    this.apiAllData = res.data;
                } else {
                    this.tipConifg['message'] = res.info;
                    this.$notify.error(this.tipConifg);
                }
            });

            getUStrategyList({token: this.token}).then(res => {
                if (res.code === 200) {
                    this.strategyList = res.data;
                } else {
                    this.tipConifg['message'] = res.info;
                    this.$notify.error(this.tipConifg);
                }
            })
        },

        addApiBtn() {// 表单提交
            this.$refs.taskForm.validate((valide) => {
                if (valide) {
                    let param = {
                        token: this.token,
                        apiId: this.formParam.apiId,
                        strategyId: this.formParam.strategyId,
                        priority: this.formParam.priority,
                        stopLoss: this.formParam.stop_loss,
                        archiveCurrency: this.formParam.archive_currency,
                        positiveLeverage: this.formParam.positive_leverage,
                        negativeLeverage:this.formParam.negative_leverage,
                        isBuy: this.formParam.is_buy ? 1 : 0,
                        isSell: this.formParam.is_sell ? 1 : 0,
                        calculateCost: this.formParam.calculate_cost,
                        initialCost: this.formParam.initial_cost
                    };

                    if (this.dialogType == 'edit') {// 编辑
                        param['apiId'] = this.formParam.taskId;
                        postUTaskEditData(param).then(res => {
                            if (res.code === 200) {
                                this.tipConifg['message'] = res.info;
                                this.addApiFlag = false;
                            } else {
                                this.tipConifg['message'] = res.info;
                            }

                            this.$notify.info(this.tipConifg);
                        });
                    } else if (this.dialogType == 'add') {// 添加任务
                        param['unit'] = this.formParam.currencyType;
                        postUnilateralTask(param).then(res => {
                            this.tipConifg.message = res.info;
                            this.$notify.info(this.tipConifg);
                            if (res.code === 200) {
                                this.addApiFlag = false;
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },

        strategySelectEvent(e) {// 策略select框事件
            this.formParam['strategyId'] = e;
        }
    }
}
</script>

<style lang="scss">
    .form-switch {
        text-align: left
    }
</style>
